'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.language = undefined;

var _actions = require('./actions');

/**
 * The language reducer
 * @param {String} state The active language id
 * @param {Object} action The action currently being processed
 * @return {string} The new state if an change language selection is received. The current state otherwise
 */
var language = exports.language = function language() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    var action = arguments[1];

    if ((0, _actions.isChangeLanguageAction)(action)) {
        return action.id;
    }

    return state;
};
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/language-common/dist/main/reducer.js
// module id = 468
// module chunks = 0